import { useState, useEffect } from "react";
import useIsMobile from "./useIsMobile";

const useContainerHeight = () => {
  const isMobile = useIsMobile();
  const [containerHeight, setContainerHeight] = useState(() => window.innerHeight);

  useEffect(() => {
    const update = () => {
      setContainerHeight(window.innerHeight);
      document.documentElement.style.setProperty("--vh", window.innerHeight * 0.01);
    };

    update();

    // Always listen to resize so desktop (even narrow windows) stays responsive
    window.addEventListener("resize", update);

    if (isMobile) {
      // Mobile: also listen to orientationchange as fallback for iOS Safari
      const onOrientationChange = () => setTimeout(update, 500);
      window.addEventListener("orientationchange", onOrientationChange);
      return () => {
        window.removeEventListener("resize", update);
        window.removeEventListener("orientationchange", onOrientationChange);
      };
    }

    return () => window.removeEventListener("resize", update);
  }, [isMobile]);

  return containerHeight;
};

export default useContainerHeight;
